import { AbstractModel } from "@lib/titan2/dist/game/model/AbstractModel";
import { Dictionary } from "@lib/titan2/dist/util/collection/Dictionary";
import { Action } from "../../api/model/enum/Action";
import { GameState } from "../../api/model/enum/GameState";
import { ReelDisplayData } from "./data/ReelDisplayData";
import { ResultData } from "./data/ResultData";
import { TicketDabData } from "./data/TicketDabData";
/**
 * SlingoModel.ts
 */
export class SlingoModel extends AbstractModel {
    constructor() {
        super();
        this.TICKET_DAB_TIMEOUT = 1;
        this.createReelDisplay();
        this.createTicketDab();
        this.createResult();
        this.firstGame = true;
        this.showWelcome = true;
        this.autoDabComplete = false;
        this.autoSpin = false;
        this.freeGamesRemaining = 0;
        this.reset();
    }
    reset() {
        super.reset();
        this.ticketDab.reset();
        this.result.reset();
        this.slingoPatterns = [];
        this.totalWin = 0;
        this.matchedPatterns = new Dictionary();
        this.collected = false;
        this.freeSpinIndex = 0;
        this.availableWinIndex = 0;
        this.currentPatternWin = 0;
        this.currentMatchedPatterns = 0;
        this.purchasedSpinTotal = 0;
        this.freeGame = false;
        this.showFreeGameWin = true;
        this.recovery = null;
        this.spinPrice = null;
        this.availableWins = null;
        this.slingoInProgress = false;
        this.sessionExpired = false;
        this.ticketDabsInProgress = [];
        this.wildCounters = [];
        this.superWildCounters = [];
        this.previousWildCounters = [];
        this.previousSuperWildCounters = [];
        this.totalWildCounters = [];
        this.totalSuperWildCounters = [];
        this.dabbedAfterStandardSpins = false;
        this.stakeToSpinAttempts = 0;
        this.stakeToSpinStarted = false;
        this.expressGame = false;
    }
    createReelDisplay() {
        this.reelDisplayData = new ReelDisplayData(5);
    }
    createTicketDab() {
        this.ticketDab = new TicketDabData();
    }
    createResult() {
        this.result = new ResultData();
    }
    addOption(type, values) {
        this.responsibleGaming.addOption(type, values);
    }
    setActions(value) {
        this.actions = value.slice();
    }
    setPriceThreshold(value) {
        this.responsibleGaming.setPriceThreshold(value);
    }
    setGameConfig(value) {
        this.gameConfig = value;
    }
    setSymbolConfig(value) {
        this.symbolConfig = value;
    }
    setPayoutConfig(value) {
        this.payoutConfig = value;
    }
    setInstructionsConfig(value) {
        this.instructionsConfig = value;
    }
    setTicket(value) {
        this.ticket = value;
        console.log(this.ticket);
    }
    setCollected(value) {
        this.collected = value;
    }
    setPreviousState(value) {
        this.previousState = value;
    }
    setPreviousPreviousState(value) {
        this.previousPreviousState = value;
    }
    setAutoDabInterval(value) {
        this.autoDabInterval = value;
    }
    setState(value) {
        this.setPreviousPreviousState(this.previousState);
        this.setPreviousState(this.state);
        this.state = value;
        switch (this.state) {
            case GameState.PURCHASE_SPIN:
                break;
            case GameState.STANDARD_SPIN:
                break;
            case GameState.FREE_SPIN:
                break;
            case GameState.PURCHASE_ENTRY:
                this.dispatchKPI("SLINGO_STATE", "PURCHASE_SELECTION_AVAILABLE", null);
                break;
            case GameState.CHOOSE_CELL:
                // this.dispatchKPI("SLINGO_STATE", "CHOOSE_CELL", null); // Need to dispatch when jokerCells are populated
                break;
            case GameState.COMPLETE:
                this.dispatchKPI("SLINGO_STATE", "GAME_ROUND_ENDED", null);
                break;
        }
    }
    setAutoSpin(value) {
        this.autoSpin = value;
    }
    setGameId(value) {
        this.gameId = value;
    }
    setGameInstanceId(value) {
        this.gameInstanceId = value;
    }
    setCurrentGame(value) {
        this.currentGame = value;
    }
    setShowFreeGameWin(value) {
        this.showFreeGameWin = value;
    }
    setFreeGame(value) {
        this.freeGame = value;
    }
    setFreeGamesRemaining(value) {
        this.freeGamesRemaining = value;
    }
    setGameProgress(value) {
        this.gameProgress = value;
    }
    setSpinResult(value) {
        this.spinResult = value;
        if (this.actions.indexOf(Action.CHOOSE_CELL) > -1) {
            const kpi = {
                jokerReels: this.spinResult?.getReelSequence().getJokerIndexes(),
                superJokerReels: this.spinResult?.getReelSequence().getSuperJokerIndexes()
            };
            this.dispatchKPI("SLINGO_STATE", "WILD_SELECTION_STARTED", JSON.stringify(kpi));
        }
    }
    setTotalWin(value) {
        this.totalWin = value;
    }
    setCurrentPatternWin(value) {
        this.currentPatternWin = value;
    }
    setSlingoPatterns(value) {
        this.slingoPatterns = value;
    }
    setCurrentMatchedPatterns(value) {
        this.currentMatchedPatterns = value;
    }
    setSpinPrice(value) {
        this.spinPrice = value;
    }
    setSymbolWins(value) {
        this.symbolWins = value;
    }
    setPatternWin(value) {
        this.patternWin = value;
    }
    setFirstGame(value) {
        this.firstGame = value;
    }
    setAutoDabComplete(value) {
        this.autoDabComplete = value;
    }
    setPurchasedSpinTotal(value) {
        this.purchasedSpinTotal = (value == null) ? 0 : value;
    }
    setFinalBalance(value) {
        this.finalBalance = value;
    }
    setRecovery(value) {
        this.recovery = value;
        //analytics
        if (this.isStakeToSpin()) {
            this.stakeToSpinStarted = true; // don't set this until the wheel has appeared for the first time
        }
    }
    setFreeSpinIndex(freeSpinIndex) {
        this.freeSpinIndex = freeSpinIndex;
    }
    setAvailableWinIndex(availableWinIndex) {
        this.availableWinIndex = availableWinIndex;
    }
    setAvailableWins(availableWins) {
        this.availableWins = availableWins;
    }
    setCompleteInterval(value) {
        this.completeInterval = value;
    }
    setBigWinThreshold(value) {
        this.bigWinThreshold = value;
    }
    setBonusBalanceEnabled(value) {
        this.bonusBalanceEnabled = value;
    }
    setCollectAvailable(value) {
        this.collectAvailable = value;
    }
    setUsePurchaseSpinTotal(value) {
        this.usePurchaseSpinTotal = value;
    }
    getFreeSpinIndex() {
        return this.freeSpinIndex;
    }
    getReelDisplayData() {
        return this.reelDisplayData;
    }
    getAvailableWinIndex() {
        return this.availableWinIndex;
    }
    getAvailableWins() {
        return this.availableWins;
    }
    getAvailableWin() {
        return this.availableWins[this.availableWinIndex];
    }
    getCurrentPatternWin() {
        return this.currentPatternWin;
    }
    getMatchedPatterns() {
        return this.matchedPatterns;
    }
    getDabData() {
        return this.ticketDab;
    }
    getRecovery() {
        return this.recovery;
    }
    getAutoDabInterval() {
        return this.autoDabInterval;
    }
    getPreviousState() {
        return this.previousState;
    }
    getState() {
        return this.state;
    }
    getCompleteInterval() {
        return this.completeInterval;
    }
    getGameInstanceId() {
        return this.gameInstanceId;
    }
    getFinalBalance() {
        return this.finalBalance;
    }
    getGameConfig() {
        return this.gameConfig;
    }
    getInstructionsConfig() {
        return this.instructionsConfig;
    }
    getCurrentGame() {
        return this.currentGame;
    }
    getSymbolConfig() {
        return this.symbolConfig;
    }
    getPayoutConfig() {
        return this.payoutConfig;
    }
    getMaxWin() {
        return this.getCurrentStake() * this.payoutConfig.getMaxPayout();
    }
    getTicket() {
        return this.ticket;
    }
    getPurchasedSpinTotal() {
        return this.purchasedSpinTotal;
    }
    getTicketId() {
        return this.ticket.getId();
    }
    getGameProgress() {
        return this.gameProgress;
    }
    getSpinResult() {
        return this.spinResult;
    }
    getSlingoPatterns() {
        return this.slingoPatterns;
    }
    getPatternWin() {
        return this.patternWin;
    }
    getResultData() {
        return this.result;
    }
    getBigWinThreshold() {
        return this.bigWinThreshold;
    }
    getShowFreeGameWin() {
        return this.showFreeGameWin;
    }
    hasFreeGameAvailable() {
        return this.freeGamesRemaining > 0;
    }
    getFreeGamesRemaining() {
        return this.freeGamesRemaining;
    }
    getSlingosAwarded() {
        return this.slingoPatterns.length;
    }
    getCurrentMatchedPatterns() {
        return this.currentMatchedPatterns;
    }
    getGameId() {
        return this.gameId;
    }
    getSpinPriceAmount() {
        return this.spinPrice ? this.spinPrice : 0;
    }
    getTotalStaked() {
        if (this.gameProgress) {
            return this.gameProgress.getTotalStaked();
        }
        let totalStake = this.getPurchasedSpinTotal();
        if (!this.isFreeGame()) {
            totalStake += this.getCurrentStake();
        }
        return totalStake;
    }
    getCurrentStake() {
        if (this.gameProgress) {
            return this.gameProgress.getStandardStake();
        }
        else {
            return super.getCurrentStake();
        }
    }
    getTotalWin() {
        return this.totalWin;
    }
    isChooseCell() {
        return this.state.isChooseCell();
    }
    isSpin() {
        return this.state.isSpin();
    }
    isPurchaseEntry() {
        return this.state.isPurchaseEntry();
    }
    isStandardSpin() {
        return this.state.isStandardSpin();
    }
    isFreeSpin() {
        return this.state.isFreeSpin();
    }
    isPurchaseSpin() {
        return this.state.isPurchaseSpin();
    }
    isComplete() {
        return this.state.isComplete();
    }
    isAutoSpin() {
        return this.autoSpin;
    }
    isFreeGame() {
        return this.freeGame;
    }
    isExtraSpinsEnabled() {
        if (this.gameConfig) {
            return this.gameConfig.getNumberOfPurchaseSpins() > 0;
        }
    }
    isFirstGame() {
        return this.firstGame;
    }
    isUsePurchaseSpinTotal() {
        return this.usePurchaseSpinTotal;
    }
    isAutoDabComplete() {
        return this.autoDabComplete;
    }
    hasCollected() {
        return this.collected;
    }
    getScatterCount() {
        return this.scatterCount;
    }
    setScatterCount(val) {
        this.scatterCount = val;
    }
    getScatterThreshold() {
        return (this.getPayoutConfig()
            ?.getSymbolPayouts()
            ?.getValue(undefined)
            ?.getMultipliers()
            ?.findIndex((multiplier) => multiplier > 0) || -1);
    }
    getScatterPrize(numberOfScatters) {
        const multiplier = this.getPayoutConfig()
            ?.getSymbolPayouts()
            ?.getValue(undefined)
            ?.getMultipliers()[numberOfScatters - 1] || 0;
        const stake = this.getCurrentStake();
        return multiplier * stake;
    }
    getSpinResultResolving() {
        return this.spinResultResolving;
    }
    setSpinResultResolving(value) {
        this.spinResultResolving = value;
        if (!value) {
            const standardSpins = this.gameConfig.getNumberOfSpins();
            const spinsRemaining = this.gameProgress.getSpinsRemaining();
            const freeSpinsAwarded = this.gameProgress.getFreeSpinsAwarded();
            const freeSpinsRemaining = this.gameProgress.getFreeSpinsRemaining();
            if (this.purchasedSpinTotal > 0) {
                let valueObj = {
                    purchaseSpin: this.gameProgress?.getPurchaseSpinsUsed(),
                };
                const failedSpins = this.spinResult?.getNextStakeToSpin()?.length || 0;
                if (this.isStakeToSpin()) {
                    if (failedSpins > 0) {
                        //failed stake to spin attempt - add one to purchaseSpin amount to show that this was a failed attempt to get the next spin
                        this.stakeToSpinAttempts = failedSpins;
                        valueObj.purchaseSpin += 1;
                        valueObj.attempt = this.stakeToSpinAttempts;
                    }
                    else if (this.stakeToSpinStarted) {
                        //successful stake to spin - increment the failed attempts value for the event, then reset it
                        valueObj.attempt = this.stakeToSpinAttempts + 1;
                        this.stakeToSpinAttempts = 0;
                    }
                }
                this.dispatchKPI("SLINGO_STATE", "PURCHASE_SPIN_RESOLVED", JSON.stringify(valueObj));
            }
            else if (this.previousState?.isFreeSpin() || (this.previousState?.isChooseCell() && this.previousPreviousState?.isFreeSpin())) {
                this.dispatchKPI("SLINGO_STATE", "FREE_SPIN_RESOLVED", JSON.stringify({ freeSpin: freeSpinsAwarded - freeSpinsRemaining }));
            }
            else {
                this.dispatchKPI("SLINGO_STATE", "STANDARD_SPIN_RESOLVED", JSON.stringify({ standardSpin: standardSpins - spinsRemaining }));
            }
            if (this.isStakeToSpin()) {
                this.stakeToSpinStarted = true; // don't set this until the wheel has appeared for the first time
            }
        }
    }
    getResponsibleGamingPriceThresholdDialogOpen() {
        return this.responsibleGamingPriceThresholdDialogOpen;
    }
    setResponsibleGamingPriceThresholdDialogOpen(value) {
        this.responsibleGamingPriceThresholdDialogOpen = value;
        if (value) {
            this.dispatchKPI("SLINGO_STATE", "PRICE_THRESHOLD_DIALOG_OPEN", null);
        }
        else if (this.responsibleGaming.isPriceConfirm()) {
            this.dispatchKPI("SLINGO_STATE", "PRICE_THRESHOLD_DIALOG_CONFIRM", null);
        }
    }
    isStakeToSpin() {
        const hasStakeToSpinAction = this.actions.indexOf(Action.STAKE_TO_SPIN) > -1;
        const hasFailedStakeToSpinAttempts = this.spinResult?.getNextStakeToSpin().length > 0;
        return hasStakeToSpinAction || hasFailedStakeToSpinAttempts;
    }
    isSpinActionAllowed() {
        return this.actions.indexOf(Action.SPIN) > -1;
    }
    isCollectActionAllowed() {
        return this.actions.indexOf(Action.COLLECT) > -1;
    }
    isWinningStakeToSpin() {
        const lastStakeToSpin = this.getLastStakeToSpin();
        return lastStakeToSpin.getRng().isWin();
    }
    hasStakeToSpin() {
        return (this.gameConfig?.getStakeToSpinEnabled() &&
            this.stake?.getMaximumPurchaseStake() > 0);
    }
    getMaximumStakeToSpinAttempts() {
        const maxAttempts = this.gameConfig?.getMaximumStakeToSpinAttempts();
        return maxAttempts > 0 ? maxAttempts : 0;
    }
    /**
     * @returns the most recent wheel spin result.
     */
    getLastStakeToSpin() {
        const nextStakeToSpin = this.spinResult.getNextStakeToSpin();
        const stakeToSpin = this.spinResult.getStakeToSpin();
        if (nextStakeToSpin?.length) {
            return nextStakeToSpin[nextStakeToSpin.length - 1];
        }
        return stakeToSpin;
    }
    getStakeToSpinAttemptsRemaining() {
        const maxAttempts = this.getMaximumStakeToSpinAttempts();
        const attempts = this.spinResult?.getNextStakeToSpin() || [];
        return maxAttempts - attempts.length;
    }
    hasStakeToSpinAttemptsRemaining() {
        if (this.getMaximumStakeToSpinAttempts() > 0) {
            return this.getStakeToSpinAttemptsRemaining() > 0;
        }
        return true;
    }
    isSlingoInProgress() {
        return this.slingoInProgress;
    }
    setSlingoInProgress(value) {
        if (value && this.slingoInProgress) {
            debugger;
        }
        this.slingoInProgress = value;
    }
    isSessionExpired() {
        return this.sessionExpired;
    }
    setSessionExpired(value) {
        this.sessionExpired = value;
    }
    setTicketDabInProgress(ticketSymbol) {
        this.ticketDabsInProgress.push(ticketSymbol);
    }
    setTicketDabComplete(ticketSymbol) {
        const index = this.ticketDabsInProgress.indexOf(ticketSymbol);
        if (index > -1) {
            this.ticketDabsInProgress.splice(index, 1);
        }
    }
    isTicketDabInProgress() {
        return this.ticketDabsInProgress.length > 0;
    }
    setJokerStored(wildCounter) {
        this.wildCounters = wildCounter;
    }
    getWildCounters() {
        return this.wildCounters;
    }
    setSuperJokerStored(superWildCounter) {
        this.superWildCounters = superWildCounter;
    }
    getSuperWildCounters() {
        return this.superWildCounters;
    }
    setPreviousJokerStored(previousWildCounter) {
        this.previousWildCounters = previousWildCounter;
    }
    getPreviousWildCounters() {
        return this.previousWildCounters;
    }
    setPreviousSuperJokerStored(previousSuperWildCounter) {
        this.previousSuperWildCounters = previousSuperWildCounter;
    }
    getPreviousSuperWildCounters() {
        return this.previousSuperWildCounters;
    }
    setTotalJokerStored(totalWildCounter) {
        this.totalWildCounters = totalWildCounter;
    }
    getTotalWildCounters() {
        return this.totalWildCounters;
    }
    setTotalSuperJokerStored(totalSuperWildCounter) {
        this.totalSuperWildCounters = totalSuperWildCounter;
    }
    getTotalSuperWildCounters() {
        return this.totalSuperWildCounters;
    }
    setDabbedAfterStandardSpins(value) {
        this.dabbedAfterStandardSpins = value;
    }
    isDabbedAfterStandardSpins() {
        return this.dabbedAfterStandardSpins;
    }
    setExpressGame(value) {
        this.expressGame = value;
    }
    isExpressGame() {
        return this.expressGame;
    }
}
//# sourceMappingURL=SlingoModel.js.map